import { useTranslation } from 'react-i18next';
import {
  TInsuranceDuplicatedMember,
  TInsurancePerson,
} from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { useInsuranceUpgradePlanConfirmationModalContent } from '@/web/containers/Insurance/InsuranceUpgrade/InsuranceUpgradePlanPage/components/InsurancePlanChooseStep/components/InsuranceUpgradePlanConfirmationModal/useInsuranceUpgradePlanConfirmationModal';
import { GenericModal } from '@coverflex-tech/hypernova';

export const InsuranceUpgradePlanConfirmationModal = ({
  planName,
  persons = [],
  displayFamilyMembersUI,
  enrolEndDate,
  allDuplicatedFamilyMembers,
  onSubmit,
  onNext,
  onClose,
  onAddFamilyMembers,
}: TInsuranceUpgradePlanConfirmationModalProps) => {
  const { t } = useTranslation();
  const {
    content,
    primaryAction,
    secondaryAction,
    hasAlreadyInsuredDuplicatedMembersSelected,
  } = useInsuranceUpgradePlanConfirmationModalContent({
    persons,
    displayFamilyMembersUI,
    enrolEndDate,
    allDuplicatedFamilyMembers,
    onSubmit,
    onNext,
    onClose,
    onAddFamilyMembers,
  });

  const title = hasAlreadyInsuredDuplicatedMembersSelected
    ? t(
        'dashboard.insurance.upgrade_plan_confirmation_modal.error.duplicated_family_members.title'
      )
    : t('dashboard.insurance.upgrade_plan_confirmation_modal.title', {
        plan: planName,
      });

  return (
    <GenericModal
      title={title}
      content={content}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      onClose={onClose}
    />
  );
};

export type TInsuranceUpgradePlanConfirmationModalProps = {
  planName?: string;
  enrolEndDate?: string;
  persons?: TInsurancePerson[];
  displayFamilyMembersUI?: boolean;
  allDuplicatedFamilyMembers: TInsuranceDuplicatedMember[];
  onClose: Function;
  onSubmit: Function;
  onNext: Function;
  onAddFamilyMembers: Function;
};
